import React, { useEffect, useRef, useState } from 'react';
import { GetReviews, SetReviews } from '../../services/Transaction';
import { handleError } from '../../utils/api';

export function RatingForm({id, title, image_url}) {
	const [rating, setRating] = useState(5);
	const [hover, setHover] = useState(0);
	const [review, setReview] = useState('');
	const retryCountRef = useRef(0);

	const handleRatingClick = (value) => {
		setRating(value);
	};

	const handleRatingHover = (value) => {
		setHover(value);
	};

	const handleReviewChange = (event) => {
		setReview(event.target.value);
	};

	const getLastReview = async () => {
		try {
			const { data } = await GetReviews({ 'data_id': id });
			if (data.results && data.results.length > 0) {
				setRating(data.results[0].rate)
				setReview(data.results[0].comment)
			}
		} catch (err) {
			handleError(err, getLastReview, retryCountRef, false, undefined)
		}
	};

	const setNewReview = async () => {
		try {
			const { data } = await SetReviews({ 'data_id': id, 'rate': rating, 'comment': review });
			if (data?.id) {
				alert('Penilaian atas '+title+' berhasil disimpan.')
			}
		} catch (err) {
			handleError(err, setNewReview, retryCountRef, false, undefined)
		}
	};

	useEffect(() => {
		const getData = async () => {
			await getLastReview();
		};

		getData();
	}, []);

	return (
		<div className="max-w-md mx-auto mt-10 p-4 bg-white rounded-lg shadow-md">
			<div className="flex items-center mb-4">
				<img src={image_url} alt={title} className="w-16 h-16 mr-4 object-cover rounded" />
				<h2 className="text-2xl font-bold mb-4">{title}</h2>
			</div>
			<div className="flex items-center mb-4">
				{[1, 2, 3, 4, 5].map((star) => (
					<button
						key={star}
						type="button"
						className={`text-2xl ${
							(hover || rating) >= star ? 'text-yellow-500' : 'text-gray-400'
						}`}
						onClick={() => handleRatingClick(star)}
						onMouseEnter={() => handleRatingHover(star)}
						onMouseLeave={() => setHover(0)}
					>
						★
					</button>
				))}
			</div>
			<textarea
				className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
				rows="4"
				placeholder="Berikan penilaianmu dan tulis review kamu disini..."
				value={review}
				onChange={handleReviewChange}
			></textarea>
			<button className="mt-4 w-full py-2 bg-blue-500 text-white font-bold rounded-md hover:bg-blue-700" onClick={setNewReview}>
				Kirim
			</button>
		</div>
	);
};
